import { DetailedHTMLProps, HTMLAttributes } from "react"
import cn from "classnames"

import style from "ui-kit/components-branded/Text/style.module.scss"
import { TextWithIcon as TextWithIconImport } from "ui-kit/components-branded/Text/TextWithIcon"

export interface TextProps
    extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
    isAccent?: boolean
    isSecondary?: boolean
    isNowrap?: boolean
    isBlock?: boolean
    textOverflowShort?: boolean
    className?: string
    color?: "secondary" | "danger"
    weight?: "medium" | "accent-tablet"
    size?: "h1" | "h2" | "h3" | "h4" | "h5"
}

export function Text({
    children,
    isAccent,
    isSecondary,
    isNowrap,
    isBlock,
    textOverflowShort,
    className,
    color,
    weight,
    size,
    ...props
}: TextProps) {
    return (
        <span
            {...props}
            className={cn(
                style.blmText,
                {
                    [style.nowrap]: isNowrap,
                    [style.block]: isBlock,
                    [style.accent]: isAccent && !isSecondary,
                    [style.secondary]: isSecondary && !isAccent,
                    [style.colorSecondary]: color === "secondary",
                    [style.colorDanger]: color === "danger",
                    [style.weightMedium]: weight === "medium",
                    [style.accentTablet]: weight === "accent-tablet",
                    [style.threeDots]: textOverflowShort,
                    [style.h1]: size === "h1",
                    [style.h2]: size === "h2",
                    [style.h3]: size === "h3",
                    [style.h4]: size === "h4",
                    [style.h5]: size === "h5",
                },
                className
            )}
        >
            {children}
        </span>
    )
}

export const TextWithIcon = TextWithIconImport
